export const tableValueFromBoolean = (value: boolean | number) => (value ? 'Yes' : 'No')
export { modalTitle, gameTeamsLabel } from './modal-title'
